import { connect } from 'react-redux';
import {
  apartmentsWithBedsSelector,
  requestApartmentsWithBedsAsync,
  resetSelectedApartmentAction,
  selectedComplexSelector,
} from '@/modules/Housing/redux/apartment';
import {
  isApartmentsWithBedsLoadingSelector,
  isArchiveApartmentLoadingSelector,
} from '@/modules/Housing/redux/loading';
import { useParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import ApartmentWithBeds from './ApartmentWithBeds';
import { Loader } from '@/components/common';
import { ApartmentModal } from '../../../components/Apartment';
import { iconMap } from '@/components/common/Icon';

const ApartmentsList = ({
  selectedComplex,
  apartmentsWithBeds,
  isApartmentsLoading,
  isArchiveApartmentLoading,
  getApartmentsWithBeds,
  resetSelected,
}) => {
  const [selectedApartmentId, setSelectedApartmentId] = useState();
  const [apartmentOpen, setApartmentOpen] = useState(false);
  const { complexId } = useParams();

  const onApartmentClose = useCallback(() => {
    setApartmentOpen(false);
    resetSelected();
    setSelectedApartmentId(null);

    if (!isArchiveApartmentLoading) {
      getApartmentsWithBeds({ complexId });
    }
  }, [resetSelected, complexId, getApartmentsWithBeds, isArchiveApartmentLoading]);

  const onApartmentClick = useCallback((apartmentId) => {
    setApartmentOpen(true);
    setSelectedApartmentId(apartmentId);
  }, []);

  const onAddApartmentClick = useCallback(() => {
    setSelectedApartmentId(null);
    setApartmentOpen(true);
  }, []);

  useEffect(() => {
    if (!isArchiveApartmentLoading) {
      getApartmentsWithBeds({ complexId });
    }
  }, [complexId, getApartmentsWithBeds, isArchiveApartmentLoading]);

  const totalRows = useMemo(() => {
    const rows = [];

    apartmentsWithBeds?.forEach((apartment) => {
      rows.push(
        <ApartmentWithBeds
          key={apartment.id}
          apartment={apartment}
          onClick={() => onApartmentClick(apartment.id)}
        />,
      );
    });

    return rows;
  }, [apartmentsWithBeds, onApartmentClick]);

  return (
    <>
      <div className="p-6 flex justify-between items-center">
        <div>
          <h2 className="text-xl font-normal">Apartments</h2>
          <div className="text-gray-600">Personal details, financial status, and activity.</div>
        </div>
        <div
          onClick={onAddApartmentClick}
          className="text-gray-600 hover:text-gray-900 inline-flex items-center hover:bg-gray-50 hover:cursor-pointer hover:bg-white align-middle"
        >
          <span className="mr-2">{iconMap.officeBuildingNewIcon}</span>
          <span className="text-sm">Add new Apartment</span>
        </div>
      </div>
      <>{isApartmentsLoading || isArchiveApartmentLoading ? <Loader className="pt-6" /> : totalRows}</>
      <ApartmentModal
        isOpen={apartmentOpen}
        complex={selectedComplex}
        onClose={onApartmentClose}
        apartmentId={selectedApartmentId}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  apartmentsWithBeds: apartmentsWithBedsSelector(state),
  isApartmentsLoading: isApartmentsWithBedsLoadingSelector(state),
  selectedComplex: selectedComplexSelector(state),
  isArchiveApartmentLoading: isArchiveApartmentLoadingSelector(state),
});

const mapDispatchToProps = {
  getApartmentsWithBeds: requestApartmentsWithBedsAsync.request,
  resetSelected: resetSelectedApartmentAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApartmentsList);
